import React from "react";
import ProjectsForm from "../../../Components/Form/ProjectsForm";

const ProjectsData = () => {
  return (
    <div>
      <h4 className="text-center">Projects Data Form</h4>
      <ProjectsForm />
    </div>
  );
};

export default ProjectsData;
